<template>
    <div>
    
      <div class="content">
        
        <div class="coder" style="width:100%; background:#eee">
          <editor v-model="code" lang="java" theme="chrome" class="editor editor-font-2" ref="aceEditor" id="codeEditor" style="border-top:1px solid #ddd"
          :options="editorOptions"
          ></editor>

          <div class="font-setting" style="top:10px">
            <div :class="font == 1?'item active':'item'" @click="changeFont(1)">小</div>
            <div :class="font == 2?'item active':'item'" @click="changeFont(2)">中</div>
            <div :class="font == 3?'item active':'item'" @click="changeFont(3)">大</div>
          </div>

          <div v-if="connected" style="right:127px;top:15px;position: absolute;background:green;width:12px;height:12px;border-radius:6px">&nbsp;</div>
          <div v-if="!connected" style="right:127px;top:15px;position: absolute;background:red;width:12px;height:12px;border-radius:6px">&nbsp;</div>

          <div style="position: absolute;right:470px;top:8px;" v-if="language != 'processing'">
            <input v-model="stdin" placeholder="stdin输入内容"/>
          </div>

          <div style="position: absolute;right:150px;top:10px">
            <select v-model="language" @change="changeLanguage">
                <option value="processing">Processing</option>
                <option value="java">Java</option>
                <option value="py3">Python</option>
                <option value="cpp">C++</option>
            </select>
          </div>

          <div v-show="language == 'processing'" style="position: fixed;text-align:center;right:0px;bottom:0px;width: 500px;display:flex;height:360px;background:white;border:1px solid #eee;">
            <canvas ref="canvas" style="max-width: 100%; max-height: 100%;margin:auto"></canvas>
          </div>

          <div v-if="resultText!=null" style="z-index:1;position: absolute;left:41px;width:calc(100% - 41px);bottom:0px;background:#ccc;height:150px;padding:10px 15px;overflow: auto">
            <div v-html="resultText"></div>

            <div style="position: absolute;top:15px;right:15px;font-size:20px;cursor: pointer;" @click="resultText = null">X</div>
          </div>
        </div>
      </div>
  
      <div class="buttons" style="right:260px;top:63px;z-index: 0;" v-if="editorOptions.showGutter">
        <img src="/images/right.png" style="width:30px;margin-right:10px;" v-if="result == 1"/>
        <img src="/images/error.png" style="width:30px;margin-right:10px;" v-if="result == 0" data-toggle="tooltip" data-placement="top" title="Tooltip on top"/>
        <button @click="run" class="btn btn-info btn-sm" style="margin-right:10px" :disabled="running">{{ running? '运行中...':'运行'}}</button>
        <button @click="stop" class="btn btn-info btn-sm" style="margin-right:10px">清除</button>
        <button @click="saveToFile" class="btn btn-info btn-sm">保存</button>
      </div>
     
    </div>
  </template>
  
  <script>
  import editor from 'vue2-ace-editor'
  import bus from '../utils/bus';
  import util from '../utils/util';
  require('brace/mode/java');
  require('brace/theme/chrome');
  
  export default {
    data() {
      return {
        code: "",
        processing: null,
        projects:[],
        classes:[],
        advanced:[],
        language:"cpp",
        exam:[],
        tab:"basic",
        font:2,
        connected:false,
        resultText:null,
        connected:false,
        running:false,
        editorOptions: {
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          enableLinking: false,
          foldStyle: 'manual',
          showGutter:true,
        },
        stdin:"",
        loopCheck:true,
        result:-1,
        error:null,
        lastLength:0,
        socket:null,
      };
    },
    components:{
      editor
    },
    mounted() {
        var lang = window.localStorage.getItem("codingLang");
        if(lang != null && lang != ''){
            this.language = lang;
        }
        setTimeout( ()=>{
          document.getElementsByClassName("ace_text-input")[0].addEventListener('paste', this.handlePaste);
        },500);

        this.connectLoop();
    },
    methods: {
      connectLoop(){
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");

        if(mobile != null && mobile != ""){
          if(!this.connected){
            this.connectServer();
          }

          var interval = setInterval( ()=>{
            if(!this.connected){
              this.connectServer();
            }
            else{
              clearInterval(interval);
            }
          },5000);
          
        }
        else{
          mobile = 's1';
          target = 't1';
          if(!this.connected){
            this.connectServer();
          }

          var interval = setInterval( ()=>{
            if(!this.connected){
              this.connectServer();
            }
            else{
              clearInterval(interval);
            }
          },5000);
        }
      },
      handlePaste(){
        if(this.socket != null){
          var mobile = util.getSearchString("mobile");
          var target = util.getSearchString("target");
          if(mobile == null || mobile == ""){
            mobile = 's1';
            target = 't1';
            
          }

          if(mobile == null || mobile == ""){
              return;
          }
          var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              this.socket.send(sendStr);
            }
            catch( err){
    
            }
        }
      },
      connectServer(){
        
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");

        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
          
        }
        
        const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
        this.socket = socket;
        // When the connection is established
        socket.addEventListener('open', event1 => {
          console.log('WebSocket connection established.');
          
          socket.send(JSON.stringify(
            {
                type:"user",
                mobile:mobile,
                target:target,
                classType:'coder',
            }));


            var interval2 = setInterval( ()=>{
              if(this.loopCheck == false){
                
                clearInterval(interval2);
                this.connected = false;
                this.connectLoop();
                return;
              }
              else{
                socket.send(JSON.stringify(
                {
                    type:"loopcheck",
                    mobile:mobile
                }))
                this.loopCheck = false;
                console.log('check successful');
              }
            },20000);


            this.connected = true;

            socket.addEventListener('message', event => {
          // 创建一个 FileReader 对象 
            const reader = new FileReader();
    
            // 当 FileReader 加载完成后，将 Blob 转换为字符串
            reader.addEventListener('loadend', () => {
              const text = reader.result;
              const data = JSON.parse(text);
              const { type, value,from } = data;
              console.log(data);
              if (type === 'classcode' && from == target) {
                // Update the editor with the new text
                this.code = value;
              }
              else if(type ==="loopcheck"){
                this.loopCheck = true;
              }
            });
    
            // 读取 Blob 内容
            reader.readAsText(event.data);
          });
    
          // // When the editor's content changes
          if(this.$refs.aceEditor){
            this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
              var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
              try{
                socket.send(sendStr);
              }
              catch( err){
              
              }
            
            });
          }
        });
  
        // When a message is received from the server
        
      },
        changeLanguage(e){
           // console.log(e.target.value);
            window.localStorage.setItem("codingLang", e.target.value);
            this.code = "";
            this.resultText = null;
        },
        saveToFile() {
      const content = this.code; // 替换成你要保存的文本内容

      // 创建Blob对象
      const blob = new Blob([content], { type: 'text/plain' });

      // 创建URL对象
      const url = window.URL.createObjectURL(blob);

      // 创建a标签
      const a = document.createElement('a');
      a.href = url;
      a.download = 'code.'; // 替换成你想要的文件名

      if(this.language == 'processing'){
        a.download += 'pde';
      }
      else if(this.language == 'cpp'){
        a.download += 'cpp';
      }
      else if(this.language == 'py3'){
        a.download += 'py';
      }
      else if(this.language == 'java'){
        a.download += 'java';
      }
      document.body.appendChild(a);

      // 模拟点击下载
      a.click();

      // 释放URL对象
      window.URL.revokeObjectURL(url);

      // 移除a标签
      document.body.removeChild(a);
    },
      changeFont(f){
        this.font = f;
        if(f == 1){
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-1");
        }
        else if(f == 2){
        
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-2");
        
        }
        else if(f == 3){
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-3");
        }
      },
     
      run() {
        if(this.running){
            return;
        }


        this.running = true;
        if(this.language == 'py3'){
            var postInfo = {};
            postInfo.code = encodeURIComponent(this.code);
            postInfo.language = 15;
            postInfo.stdin = this.stdin;
            postInfo.fileext = "py3";

            this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
              console.log(response.data);
              this.running = false;
              this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
            });
            return;
        }

        else if(this.language == 'cpp'){
            var postInfo = {};
            postInfo.code = encodeURIComponent(this.code);//.replace(/\n/g,'');
            postInfo.language = 7;
            postInfo.stdin = this.stdin;
            postInfo.fileext = "cpp";

            this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
              console.log(response.data);
              this.running = false;
              this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
            });

            return;
        }

        else if(this.language == 'java'){
            var postInfo = {};
            postInfo.code = encodeURIComponent(this.code);
            postInfo.language = 8;
            postInfo.stdin = this.stdin;
            postInfo.fileext = "java";

            this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
              console.log(response.data);
              this.running = false;
              this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
            });

            return;
        }

        


        this.result = -1;
        this.error = null;
        if(this.processing != null){
          this.processing.exit();
          this.processing = null;
        }
  
        var elements1 = document.getElementsByClassName("ace_gutter-cell");
        for(var i=0;i<elements1.length;i++){
          elements1[i].className = "ace_gutter-cell";
        }
  
        try{
          this.processing = new Processing(this.$refs.canvas, this.code);
          console.log(this.processing)
          this.result = 1;
          this.running = false;
        }
        catch(err){
          this.result = 0;
          this.error = err;
          console.log(err);
          this.running = false;
        } 
      },
      stop() {
        this.code = "";
        this.result = -1;
        this.error = null;
        this.processing.exit();
      },
    },
  };
  </script>
  
  <style lang="scss">
  
  .content{
    position: fixed;
    top:56px;
    left:0px;
    width:100%;
    height:calc(100% - 56px);
    display: flex;
  
    .coder{
      width:60%;
      height:100%;
      overflow: auto;
      position: relative;
  
      .editor{
        width:100%;
        height:100%;
        background:#f5fdfb;
        
  
        .ace_print-margin{
          display: none;
        }

        &.editor-font-1{
          font-size: 12px !important;
        }

        &.editor-font-2{
          font-size: 14px !important;
        }

        &.editor-font-3{
          font-size: 16px !important;
        }
      }

      .font-setting{
        position: absolute;
        right:10px;
        top:10px;
        display: flex;
        border: 1px solid #eee;

        .item{
          width:35px;
          text-align: center;
          font-size:14px;
          background:white;
          cursor: pointer;

          &.active{
            background:#04b2c5;
            color:white;
          }
        }
      }
    }
    .panel{
      width:40%;
      border-left:1px solid #eee;
      .result{
        width:100%;
        height:50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-bottom:1px solid #eee;
  
        .title{
          position: absolute;
          top:0px;
          left:0px;
          width:100%;
          padding:10px;
          font-weight:bold;
          font-size:14px;
        }
        canvas{
          max-width:100%;
          max-height:100%;
        }
      }
  
      .notes{
        width:100%;
        height:50%;
        //background:black;
        overflow: auto;
  
        .tabs{
          display: flex;
          
          font-size:14px;
          justify-content: space-around;
          .tab{
            width:50%;
            text-align: center;
            padding:10px 0px;
            cursor: pointer;
            border-bottom: 1px solid #eee;;
            
            &.active{
              background: #04b2c5;
              
              color:white;
            }
          }
        }
      }
    }
  }
  
  .buttons{
    position: fixed;
    bottom:10px;
    right:41%;
    z-index: 10;
  }
  
  .ace_gutter-cell.error-line{
    background:orangered;
    color:white;
  }
  
  
  .ace_gutter-cell .ace_fold-widget{
    display: none !important
  }

  
  .pjsconsole{
    width:60%;
    height:150px !important;
    .console{
      overflow-y: auto !important;
      height:150px !important;
      padding-bottom:20px;
    }
  }
  
  .project-row{
    display:flex;
    justify-content: space-between;
    padding:5px 10px;
    font-size:15px;
    cursor: pointer;
  
    &:hover{
      background:#eee;
    }
  }
  
  .class-row{
    padding:5px 10px;
    font-size:15px;
    cursor: pointer;
  
    &:hover{
      background:#eee;
    }
  }
  
  .topic-row{
    cursor: pointer;
    font-size:13px;
    padding:3px 20px;
    padding-right:8px;
    display: flex;
    color:#666;
    justify-content: space-between;
  
    &:hover{
      background:#eee;
    }
  }
  
  .error-layer{
    position: fixed;
    bottom:0px;
    height:180px;
    left:0px;
    width:60%;
    background:#eee;
    border-top:1px solid #ccc;
  }
  .ace_identifier{
    color:rgb(189, 60, 1);
  
  }
  
  .ace_numeric{
    color:#038795 !important;
  }
  
  .ace_keyword{
    color:rgb(43, 90, 1) !important;
  
  }
  </style>